
/**
 * 메시지 역할
 */
export type ChatRequestMessagesItemRole = typeof ChatRequestMessagesItemRole[keyof typeof ChatRequestMessagesItemRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatRequestMessagesItemRole = {
  user: 'user',
  assistant: 'assistant',
  system: 'system',
} as const;
